import { render, staticRenderFns } from "./ProgramDetailPage.vue?vue&type=template&id=85cd3498&scoped=true&"
import script from "./ProgramDetailPage.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailPage.vue?vue&type=style&index=0&id=85cd3498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cd3498",
  null
  
)

export default component.exports